var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-list-nav"},[_c('div',{staticClass:"m-nav-group"},_vm._l((_vm.menu),function(item,i){return _c('router-link',{key:i,staticClass:"u-item",class:{ on: _vm.isActive(item) },attrs:{"to":{ name: item.routeName }}},[_c('i',{class:item.icon}),_c('span',{staticClass:"u-text"},[_vm._v(_vm._s(item.name))])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }